<template>
  <div class="sign-up">
    <div v-if="step === 1" class="sign-up__card cards__single" key="step1">
      <div class="sign-up__header">
        <div class="sign-up__title h1">
          {{ $vuetify.lang.t('$vuetify.signup.hello') }}
        </div>
      </div>
      <v-form ref="form" class="sign-up__form" @submit.prevent="">
        <v-text-field
          v-model="profile.name"
          :label="$vuetify.lang.t('$vuetify.signup.name')"
          outlined
          :rules="[$rules.required, $rules.text]"
        ></v-text-field>
        <v-text-field
          v-model="profile.lastname"
          :label="$vuetify.lang.t('$vuetify.signup.lastname')"
          outlined
          :rules="[$rules.required, $rules.text]"
        ></v-text-field>
        <v-text-field
          v-model="profile.phone"
          :label="$vuetify.lang.t('$vuetify.phone')"
          outlined
          :rules="[$rules.required]"
        ></v-text-field>
        <div class="error--text" v-if="alertError">{{ alertMsg }}</div>
        <div class="sign-up__buttons btn-group">
          <div
            class="btn btn-secondary"
            @click="deleteUser"
          >
            {{ $vuetify.lang.t('$vuetify.signup.cancel') }}
          </div>
          <button class="btn btn-primary" @click="addProfile">{{ $vuetify.lang.t('$vuetify.forward') }}</button>
        </div>
      </v-form>
    </div>

    <SpinnerLoader :overlay="loader"></SpinnerLoader>

    <div v-if="step === 7" class="sign-up__card cards__single" key="step11">
      <div class="sign-up__header">
        <div class="sign-up__title h1">{{ $vuetify.lang.t('$vuetify.signup.congratTitle') }}</div>
        <div class="sign-up__subtitle">
          {{ $vuetify.lang.t('$vuetify.signup.congratSubtitle') }}
        </div>
      </div>
      <button class="sign-up__final btn btn-primary" @click="goLoginPage">
        {{ $vuetify.lang.t('$vuetify.gotoProfile') }}
      </button>
    </div>
  </div>
</template>

<script>
import SpinnerLoader from "@/components/SpinnerLoader";

export default {
  name: "SignUpLayout",
  components: {
    SpinnerLoader,
  },
  props: {
    mode: String,
    id: [String, Number]
  },
  data: function () {
    return {
      url: "",
      admin: false,
      profile: {
        id: 0,
        name: "",
        lastname: "",
        phone: "",
      },
      currentGroup: {},
      groups: [],
      valid: true,
      step: 1,
      loader: false,
      alertError: false,
      alertMsg: "",
    };
  },
  watch: {
    profile: {
      deep: true,
      handler() {
        this.$saveForm('newProfile', this.profile)
      }
    }
  },

  created() {
    if (!(localStorage.getItem("auth_token") || sessionStorage.getItem("auth_token"))) {
      this.$router.push({name: "AuthLayout"});
    } else {
      this.$axios({
        url: this.$hostname + "time-tracking/check-profile/" + this.id,
        method: "GET",
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
      }).then((response) => {
        if (response.data.data.data === true) {
          alert(this.$vuetify.lang.t("$vuetify.userExists"))
          this.$router.push({name: "main"});
        } else {
          this.admin = response.data.data.admin
          if (this.mode === 'worker' && this.admin === true) {
            this.url = "time-tracking/profiles"
            this.loadGroups();
          } else if (this.admin === true) {
            this.$router.push({path: `/signup/${'worker'}/${this.id}`});
          } else {
            this.url = "time-tracking/register-profile"
          }
          if (Object.keys(this.$loadForm('newProfile')).length !== 0)
            this.profile = this.$loadForm('newProfile')
        }
      }).catch((error) => {
        this.alertMsg = this.$catch(error)
        alert(this.alertMsg);
      })
    }
  },

  methods: {
    loadGroups() {
      if (this.admin) {
        this.$axios({
          url: this.$hostname + "time-tracking/groups",
          method: "GET",
          headers: {
            Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                sessionStorage.getItem("auth_token")),
          },
        }).then((response) => {
          this.groups = response.data.data.groups
          this.groups.forEach(group => {
            group.name = JSON.parse(group.name)
          })
        }).catch((response) => {
          this.alertMsg = this.$catch(response)
          this.alertError = true
        })
      }
    },

    addProfile() {
      if (this.$refs.form.validate()) {
        this.loader = true
        this.$axios({
          url: this.$hostname + this.url,
          method: "POST",
          headers: {
            Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                sessionStorage.getItem("auth_token")),
            "Content-Type": "multipart/form-data",
          },
          data: {
            auth_user_id: this.id,
            name: this.profile.name,
            lastname: this.profile.lastname,
            phone: this.profile.phone,
          },
        })
          .then((response) => {
            this.profile.id = response.data.data.id
            this.editGroup()
            this.$clearForm('newProfile')
            this.step = 7;
            this.loader = false
          })
          .catch((error) => {
            this.loader = false
            this.alertMsg = this.$catch(error)
            alert(this.alertMsg);
          });
      }
    },
    editGroup() {
      if (this.admin) {
        this.$axios({
          url: this.$hostname + "time-tracking/user-groups",
          method: "PUT",
          headers: {
            Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                sessionStorage.getItem("auth_token")),
            "Content-Type": "multipart/form-data",
          },
          data: {
            auth_user_id: this.id,
            group_id: this.currentGroup.id
          },
        }).then((response) => {
          this.currentGroup.name = response.data.data.data[0]
        }).catch((response) => {
          this.alertMsg = this.$catch(response)
          this.alertError = true
        })
      }
    },
    deleteUser() {
      this.$axios
        .delete(this.$hostname + "time-tracking/register-user", {
          data: {
            id: this.id,
          },
          headers: {
            Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                sessionStorage.getItem("auth_token")),
            "Content-Type": "multipart/form-data",
          },
        })
        .then(() => {
          this.alertMsg = "Пользователь удален";
          if (this.mode !== 'worker') {
            localStorage.clear()
            sessionStorage.clear()
            this.goLoginPage()
          } else {
            this.$router.push({name: 'workers'})
          }
        })
        .catch((response) => {
          this.alertMsg = this.$catch(response);
          this.alertError = true;
        });
    },
    goLoginPage() {
      this.$router.push({name: "AuthLayout"});
    },
  }
};
</script>

<style scoped></style>
